export const GET_ALL_CONTRACTORS = 'GET_ALL_CONTRACTORS';